import React, { FC } from 'react';
import { MilestoneBillingListGrid } from './grids';

const MilestoneBillingList: FC<{ isSensitiveDataIsShown?: boolean }> = ({ isSensitiveDataIsShown }) => {
  return <MilestoneBillingListGrid isSensitiveDataIsShown={isSensitiveDataIsShown} />;
};

export default MilestoneBillingList;
